// extracted by mini-css-extract-plugin
export var content = "_4f-3";
export var list = "_4f-4";
export var settingsContent = "_4f-7";
export var settingsPanel = "_4f-8";
export var state = "_4f-6";
export var triggerBadge = "_4f-2";
export var triggerButton = "_4f-1";
export var triggerShell = "_4f-0";
export var unreadDot = "_4f-5";